<template>
    <app-layout>
        <template #title> Kiosk </template>
        <template #description> </template>
        <template #actions>
            <inertia-link
                :href="route('app.kiosk.users.create')"
                type="button"
                class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                >Add user</inertia-link
            >
        </template>

        <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="px-4 sm:px-6 lg:px-8">
                <div class="flex">
                    <div class="flex flex-col items-center">
                        <p class="font-medium">Verification</p>
                        <DonutChart
                            class="mt-4"
                            :data="verificationDonutChartData"
                            :index="'name'"
                            :category="'total'"
                        ></DonutChart>
                    </div>

                    <div class="flex flex-col items-center">
                        <p class="font-medium">Lanaguage usage</p>
                        <DonutChart
                            class="mt-4"
                            :data="numberOfUsersDonutChartData"
                            :index="'name'"
                            :category="'total'"
                        ></DonutChart>
                    </div>
                </div>

                <div class="mt-16">
                    <p class="font-medium">Signups by month (last 12 months)</p>

                    <Deferred data="stats">
                        <template #fallback>
                            <div class="h-[400px]">Loading...</div>
                        </template>

                        <BarChart
                            :data="stats"
                            index="name"
                            :categories="['total', 'verified']"
                            :colors="['#84ADFF', '#7CD4FD']"
                            :y-formatter="
                                (tick, i) => {
                                    return String(tick);
                                }
                            "
                            :custom-tooltip="BarChartTooltip"
                        ></BarChart>
                    </Deferred>
                </div>
                <div class="mt-16 sm:flex sm:items-center">
                    <div class="sm:flex-auto">
                        <!--                        <h1 class="text-xl font-semibold text-iron-900">Users</h1>-->
                    </div>
                    <Button class="mr-2" @click="clearFilters"
                        >Clear Filters</Button
                    >
                    <Button variant="outline" @click="filterAffilPartners"
                        >Filter Affiliate partners</Button
                    >
                </div>

                <div class="mt-8 flex w-full justify-between">
                    <p class="mt-2 font-medium text-iron-700">
                        Results: {{ filteredUsers.length }}
                    </p>

                    <div class="relative w-full max-w-sm items-center">
                        <Input
                            v-model="searchQuery"
                            id="search"
                            type="text"
                            placeholder="Search users by email..."
                            class="pl-10"
                        />
                        <span
                            class="absolute inset-y-0 start-0 flex items-center justify-center px-2"
                        >
                            <Search class="size-6 text-muted-foreground" />
                        </span>
                    </div>
                </div>

                <div class="mt-4 flex flex-col">
                    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div
                            class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
                        >
                            <div
                                class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                            >
                                <table
                                    class="min-w-full divide-y divide-iron-300"
                                >
                                    <thead class="bg-iron-50">
                                        <tr>
                                            <th
                                                scope="col"
                                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-iron-900 sm:pl-6"
                                            >
                                                Name
                                            </th>
                                            <th
                                                scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-iron-900"
                                            >
                                                Email
                                            </th>
                                            <th
                                                scope="col"
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-iron-900"
                                            >
                                                Type
                                            </th>

                                            <th
                                                scope="col"
                                                class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                                            >
                                                <span class="sr-only"
                                                    >Impersonate</span
                                                >
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody
                                        class="divide-y divide-iron-200 bg-white"
                                    >
                                        <tr
                                            v-for="user in filteredUsers"
                                            :key="user.id"
                                        >
                                            <td
                                                class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-iron-900 sm:pl-6"
                                            >
                                                {{ user.name }}
                                            </td>
                                            <td
                                                class="whitespace-nowrap px-3 py-4 text-sm text-iron-500"
                                            >
                                                {{ user.email }}
                                            </td>

                                            <td
                                                class="whitespace-nowrap px-3 py-4 text-sm text-iron-500"
                                            >
                                                <button
                                                    v-if="
                                                        user.affiliate_partner ===
                                                        false
                                                    "
                                                    @click="filterBy(user.type)"
                                                >
                                                    <div
                                                        class="rounded-md bg-stone-200 px-1 py-1 text-center text-xs font-semibold uppercase"
                                                        :class="[
                                                            user.type ===
                                                            'admin'
                                                                ? 'bg-blue-200 text-blue-800'
                                                                : user.type ===
                                                                    'regular'
                                                                  ? 'bg-stone-200 text-stone-800'
                                                                  : 'bg-yellow-200 text-yellow-800',
                                                        ]"
                                                    >
                                                        {{ user.type }}
                                                    </div>
                                                </button>

                                                <button
                                                    @click="filterBy('affil')"
                                                    v-else
                                                >
                                                    <div
                                                        class="rounded-md bg-yellow-200 px-1 py-1 text-center text-xs font-semibold uppercase text-yellow-800"
                                                    >
                                                        Affiliate
                                                    </div>
                                                </button>
                                            </td>

                                            <td
                                                class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                                            >
                                                <inertia-link
                                                    v-if="
                                                        user.id !==
                                                        $page.props.userId
                                                    "
                                                    :href="
                                                        route(
                                                            'app.kiosk.users.show',
                                                            { user: user.id },
                                                        )
                                                    "
                                                    class="text-indigo-600 hover:text-indigo-900"
                                                >
                                                    View
                                                    <span class="sr-only"
                                                        >, {{ user.name }}</span
                                                    >
                                                </inertia-link>
                                                <inertia-link
                                                    v-if="
                                                        user.id !==
                                                        $page.props.userId
                                                    "
                                                    :href="
                                                        route(
                                                            'app.kiosk.users.impersonate',
                                                            { user: user.id },
                                                        )
                                                    "
                                                    class="ml-2 text-indigo-600 hover:text-indigo-900"
                                                >
                                                    Impersonate
                                                    <span class="sr-only"
                                                        >, {{ user.name }}</span
                                                    >
                                                </inertia-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div
                    class="overflow-hidden bg-white shadow-xl sm:rounded-lg"
                ></div>
            </div>
        </div>
    </app-layout>
</template>

<script setup lang="ts">
import AppLayout from "../../../../Layouts/AppLayout.vue";
import route from "ziggy-js";
import { Button } from "../../../../components/ui/button";
import { Input } from "../../../../components/ui/input";
import { ref, watch } from "vue";
import { DonutChart } from "@/components/ui/chart-donut";
import { BarChart } from "@/components/ui/chart-bar";
import { Search } from "lucide-vue-next";
import BarChartTooltip from "./components/BarChartTooltip.vue";
import { Deferred } from "@inertiajs/vue3";

type Stats = {
    total: number;
    name: string;
    verified: number;
    views: number;
};

const props = defineProps<{ users: any[]; stats: Stats[] }>();

const filteredUsers = ref(props.users);
const filtered = ref(false);

type UserType = "admin" | "regular" | "affil";

const searchQuery = ref("");

function filterBy(type: UserType) {
    filtered.value = true;
    if (type === "affil") {
        filterAffilPartners();
        return;
    }

    filteredUsers.value = props.users.filter((user) => user.type === type);
}

function filterAffilPartners() {
    filteredUsers.value = props.users.filter(
        (user) => user.affiliate_partner === true,
    );
}

function clearFilters() {
    filteredUsers.value = props.users;
    filtered.value = false;
}

const verificationDonutChartData = prepareVerificationDonutChartData(
    props.users,
);

const numberOfUsersDonutChartData = prepareLanguageDonutChartData(props.users);

watch(searchQuery, (newV, oldV) => {
    if (oldV !== newV) {
        filteredUsers.value = props.users.filter((user) => {
            return user.email.toLowerCase().includes(newV.toLowerCase());
        });
    }
});

function prepareVerificationDonutChartData(users: any) {
    const verified = users.filter(
        (user: any) => user.email_verified_at !== null,
    ).length;
    const unverified = users.filter(
        (user: any) => user.email_verified_at === null,
    ).length;
    return [
        { total: verified, name: "verified" },
        { total: unverified, name: "unverified" },
    ];
}

function prepareLanguageDonutChartData(users: any) {
    const numberOfCs = users.filter((user: any) => user.lang === "cs").length;
    const numberOfEn = users.filter((user: any) => user.lang === "en").length;
    return [
        { total: numberOfCs, name: "cs" },
        { total: numberOfEn, name: "en" },
    ];
}
</script>
